import { createFileRoute, redirect } from '@tanstack/react-router'
import { RapidApiUsagePage } from '@/pages/RapidApi/RapidApiUsagePage'
import { useAuthStore } from '@/store/authStore'
import { canAccessRoute } from '@/lib/roles'

export const Route = createFileRoute('/_authenticated/rapidapi')({
  component: RapidApiUsagePage,
  beforeLoad: () => {
    const role = useAuthStore.getState().user?.role
    if (!canAccessRoute(role, '/rapidapi')) {
      throw redirect({ to: '/' })
    }
  },
})
